import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createRole, updateRole } from '@/store/thunks/roleThunks';
import type { Role } from '@/types';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  name: Yup.string().required('Nom obligatoire'),
  code: Yup.string(),
});

interface RoleFormProps {
  role?: Role | null;
  type: 'create' | 'update';
  onClose: () => void;
  onSuccess?: () => void;
}

export default function RoleForm({ role, type, onClose, onSuccess }: RoleFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      name: role?.name ?? role?.code ?? '',
      code: role?.code ?? '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (type === 'update' && role?.id) {
        const res = await dispatch(updateRole({ ...role, ...values }));
        if (updateRole.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      } else {
        const res = await dispatch(createRole(values));
        if (createRole.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input
        label="Nom"
        id="name"
        {...formik.getFieldProps('name')}
        error={formik.touched.name ? formik.errors.name : undefined}
      />
      <Input label="Code" id="code" {...formik.getFieldProps('code')} />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
        <Button type="submit" loading={formik.isSubmitting}>{type === 'update' ? 'Modifier' : 'Créer'}</Button>
      </div>
    </form>
  );
}
